export const ArticleTemplate = {
  template: "ArticleTemplate",
  data: {
    header: null,
    content: [],
  },
};
